import React from 'react';
import { Container } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import Header from '../Header/Header';
import iphone1 from '../../images/project1-iphone.png';
import ipad1 from '../../images/project1-ipad.png';
import mac1 from '../../images/project1-mac.png';
import iphone2 from '../../images/project2-iphone.png';
import ipad2 from '../../images/project2-ipad.png';
import mac2 from '../../images/project2-mac.png';
import iphone3 from '../../images/project3-iphone.png';
import ipad3 from '../../images/project3-ipad.png';
import mac3 from '../../images/project3-mac.png';
import iphone4 from '../../images/project4-iphone.png';
import iphone5 from '../../images/project5-iphone.png';
import ipad5 from '../../images/project5-ipad.png';
import mac5 from '../../images/project5-mac.png';
import iphone6 from '../../images/project6-iphone.png';
import ipad6 from '../../images/project6-ipad.png';
import mac6 from '../../images/project6-mac.png';
import { useState } from 'react';
import { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles


const projects = [
    {
        name: "BREVEMOD. - Hack Melbourne 2022",
        img: "https://i.ibb.co/CmfM7RB/project1.png",
        id: 1,
        details: `BREVEMOD is made up of two parts: BREVE and MOD. "BREVE" is a Latin term for "short," and "MOD" is derived from the word "modules." Overall, BREVEMOD demonstrates short modules. BREVEMOD focuses on two major things: daily learning and creating urgency for the students to make them persistent.`,
        iphone: iphone1,
        ipad: ipad1,
        mac: mac1,
        links: [
            { live: "https://brevemod.web.app/" },
            { devpost: "https://devpost.com/software/brevmod" },
            { frontend: "https://github.com/shadmansaalim/Melb-Hack" },
            { backend: "https://github.com/shadmansaalim/Melb-Hack-Backend" },
        ],
        technologies: [
            "React Js",
            "React Router",
            "Node Js",
            "Express Js",
            "MongoDB",
            "React Bootstrap",
            "Firebase"
        ],
        overview: [
            "I got the second place in Hack Melbourne 2022 for this project",
            "Instructors publishes daily short modules for students to instil in them a habit of learning",
            "Module consists of some videos followed by a quiz",
            "Quizzes will help students to practice as they will cover video topics.",
            "Students are prevented from accessing new modules or videos until they have completed the one they are working on.",
            "INSTRUCTOR CREDENTIALS (email: timothy@gmail.com, password: 123456)"
        ]
    },

    {
        name: "CarSales - Full Stack Application",
        img: "https://i.ibb.co/Zh58Wqf/project2.png",
        id: 2,
        details: "This is a simple niche application where cars are displayed and users can book them. The application has a User Dashboard Profile system along with an Admin Panel.",
        iphone: iphone2,
        ipad: ipad2,
        mac: mac2,
        links: [
            { live: "https://full-stack-car-app.web.app/" },
            { frontend: "https://github.com/shadmansaalim/Full-Stack-Car-Client" },
            { backend: "https://github.com/shadmansaalim/Full-Stack-Car-Server" },
        ],
        technologies: [
            "React Js",
            "React Router",
            "Node Js",
            "Express Js",
            "MongoDB",
            "Bootstrap",
            "Firebase",
            "JWT Token"
        ],
        overview: [
            "Implemented a User Dashboard Profile for interacting with the application.",
            "Developed an Admin Panel for admins to manage the app - Please drop me a text for admin credentials.",
            "Secured the application by implementing Private Routes & a JWT Token.",
            "Implemented an Image Uploading System for Admins to Add Cars.",
            "Built Backend APIs and handled CRUD operations",
            "Users can add review which will be added to the home page.",
            "100% Responsive Application."
        ]
    },
    {
        name: "Udemy - Full Stack Application",
        img: "https://i.ibb.co/CmfM7RB/project1.png",
        id: 3,
        details: "An application where users can create an account or login with an existing account and can look for their desired courses and add them to their cart for purchase.",
        iphone: iphone3,
        ipad: ipad3,
        mac: mac3,
        links: [
            { live: "https://react-course-app-88b8d.web.app/" },
            { frontend: "https://github.com/shadmansaalim/Full-Stack-Course-App" },
            { backend: "https://github.com/shadmansaalim/Full-Stack-Course-Backend" },
        ],
        technologies: [
            "React Js",
            "React Router",
            "Node Js",
            "Express Js",
            "MongoDB",
            "Bootstrap",
            "Firebase",
            "Nodemailer",
            "JWT Token",
            "Stripe API"
        ],
        overview: [
            "Implemented Firebase Authentication System for users to create account or login.",
            "Developed Context API and used Local Storage for letting users to add courses to cart and later review them.",
            "Used Stripe Payment to let users pay for courses and also used Nodemailer for sending subscription mail to users.",
            "Implemented Private Routes and a JWT Token to secure the application",
            "Implemented basic Nielson Design Principles to improve the User Experience of the application.",
            "Users can add review to courses which will be instantly added to course details page.",
            "100% Responsive Application."
        ]
    },
    {
        name: "React Native Mobile App",
        img: "https://i.ibb.co/rdZSnQv/project5.png",
        id: 4,
        details: "This is an application that I personally use for getting information about viruses, and the aesthetic UI makes it more user-friendly.",
        iphone: iphone4,
        links: [
            { live: "https://expo.dev/@shadmansaalim/covid-app" },
            { frontend: "https://github.com/shadmansaalim/React-Native-Covid-App" },
        ],
        technologies: [
            "React Native",
            "Native Base",
            "React Navigation",
            "Mobile Application Development",
        ],
        overview: [
            "My first developed Mobile Application",
            "Simple React Native Application.",
            "Covid App with real time data using API.",
            "Used React Navigation to navigate between pages",
            "Simple UI/UX design for better User Experience.",
        ]
    },
    {
        name: "BYOCC - Hackathon Project 2021",
        img: "https://i.ibb.co/bPXMs7y/project3.gif",
        id: 5,
        details: "I got Second Place and Best UI Design Award for developing an application that leads to sustainability within 24 hours.",
        iphone: iphone5,
        ipad: ipad5,
        mac: mac5,
        links: [
            { devpost: "https://devpost.com/software/byocc" }
        ],
        technologies: [
            "Next Js",
            "React",
            "Node Js",
            "MongoDB",
            "Chakra UI",
            "Firebase",
            "Figma"
        ],
        overview: [
            "I did this project in a Hackathon which was sponsored by Google.",
            "Led a team throughout the hackathon and worked on full backend API and CRUD operations alone.",
            "Developed and improved Front-end components and helped the team with technical issues and bugs.",
            "Took a challenge and worked with NextJs and Chakra UI for the first time on a hackathon.",
            "100% Responsive Application",
            "Deployment on process live site will come soon."
        ]
    },
    {
        name: "Ambulance Service",
        img: "https://i.ibb.co/NjJWwKX/project4.png",
        id: 6,
        details: "An application which makes Ambulance Service more reachable to people easily. Users can choose different service and book them with details.",
        iphone: iphone6,
        ipad: ipad6,
        mac: mac6,
        links: [
            { live: "https://react-healthcare.web.app/" },
            { frontend: "https://github.com/shadmansaalim/React-Ambulance" },
        ],
        technologies: [
            "React Js",
            "React Router",
            "Bootstrap",
            "Sweetalert",
            "Firebase",
        ],
        overview: [
            "This is a serious real world application and is very common in our daily life so this project gave me an idea of Real World Applications.",
            "Implemented Firebase Authentication System for users to create account and login.",
            "Used React Router to generate dynamic routes",
            "Implemented Private Routes to hide from unauthorized users.",
            "100% Responsive Application",
            "Passionate and Interested do more Real World Projects in Future."
        ]
    }
]

const ProjectDetails = () => {
    const colors = ["#3984ff", "#fa5649", "#ffa113", "#5a00dd"];
    const { id } = useParams();
    const [project, setProject] = useState({});
    useEffect(() => {
        setProject(projects.find(p => p.id === parseInt(id)))
        AOS.init({
            duration: 2500,
        });
        AOS.refresh()
    }, [id])
    console.log(project)
    return (
        <div style={{ backgroundColor: '#141c3a', height: "100vh" }}>
            {
                (project?.iphone || project?.video)
                    ?

                    <div>
                        <Header></Header>
                        <Container className="details mx-auto w-100" style={{ overflowX: 'hidden' }}>
                            <div className="row w-100 d-flex align-items-start text-white mx-0">
                                <div data-aos="fade-right" className="col-xl-6">

                                    {
                                        project.mac && project.ipad
                                            ?
                                            <div className="row my-5 d-flex align-items-start w-100">
                                                <div className="col-6">
                                                    <div>
                                                        <img className="img-fluid" src={project.iphone} alt="" />
                                                    </div>
                                                </div>
                                                <div className="col-6">
                                                    <div>
                                                        <img className="img-fluid" src={project?.mac} alt="" />
                                                        <img className="img-fluid" src={project?.ipad} alt="" />
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            project?.iphone
                                                ?
                                                <div className="row my-5 d-flex align-items-start w-100">
                                                    <div className="col-8 mx-auto">
                                                        <div>
                                                            <img className="img-fluid" src={project.iphone} alt="" />
                                                        </div>
                                                    </div>
                                                </div>
                                                :
                                                <div className="row my-5 d-flex align-items-start w-100">


                                                    <iframe width="100%" height="315" src={project.video} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen={true}></iframe>

                                                </div>
                                    }

                                </div>
                                <div data-aos="fade-left" className="col-xl-6 mt-lg-5 text-start" style={{ overflow: 'hidden' }}>
                                    <h2 className="fw-bold mb-3">{project.name}</h2>
                                    <p>{project.details}</p>
                                    <ul>
                                        {
                                            project.overview.map(point => <li className="mb-2">{point}</li>)
                                        }
                                    </ul>

                                    <div data-aos="fade-up-left">
                                        <h4 className="fw-bold">Technologies</h4>
                                        <div className="d-flex flex-wrap align-items-center mx-auto">

                                            {
                                                project.technologies.map(technology =>
                                                    <button className="btn rounded-pill my-2 me-3" style={{
                                                        backgroundColor: (colors[Math.floor(Math.random() * colors.length)]),
                                                        color: 'white'
                                                    }}>{technology}</button>
                                                )
                                            }

                                        </div>

                                        <div className="mt-3 row row-cols-1 row-cols-lg-3">
                                            {
                                                project?.links
                                                &&
                                                project.links.map(link => {
                                                    let linkName = Object.keys(link)[0];
                                                    linkName = linkName.charAt(0).toUpperCase() + linkName.slice(1)
                                                    if (linkName === 'Frontend' || linkName === 'Backend') {
                                                        linkName = linkName + " Code";
                                                    }
                                                    return (
                                                        <div className="mb-3">
                                                            <a target="_blank" rel="noreferrer" href={link[Object.keys(link)[0]]} className="btn btn-success w-100">
                                                                {linkName}
                                                                <i className="fas fa-code ms-1"></i>
                                                            </a>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </Container>
                    </div>
                    :
                    <div style={{ backgroundColor: '#141c3a' }}>
                        <div className="spinner d-flex align-items-center justify-content-center">
                            <div className="bounce1"></div>
                            <div className="bounce2"></div>
                            <div className="bounce3"></div>
                        </div>
                    </div>
            }
        </div>
    );
};

export default ProjectDetails;